import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestService } from '../../../services/request.service';

@Component({
  selector: 'app-restart-arruolamento-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './restart-arruolamento-modal.component.html',
  styleUrl: './restart-arruolamento-modal.component.scss',
})
export class RestartArruolamentoModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<any>();

  note: string = '';
  type: number | null = null;
  causes: any[] = [];

  constructor(private requestService: RequestService) {}

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    this.confirmed.emit();
  }

  ngOnInit() {
  }
}
